import { useEffect } from 'react';

const TawkToLoader = () => {
  useEffect(() => {
    if (window.Tawk_API) return;

    const script = document.createElement('script');
    script.src = 'https://embed.tawk.to/6806e4235a57ed191709edb0/1ipdemb5p';
    script.async = true;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);

    return () => {
      // opcional: cleanup si tuvieras un teardown
      // document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default TawkToLoader;
